module.exports = __webpack_public_path__ + "img/delano2.e1d8062b.jpg";